module.exports = __webpack_public_path__ + "img/hjasj19.aad5726a.png";